// Mock Data for Giovanni Tende

export const companyInfo = {
  name: "Giovanni Tende",
  fullName: "GIOVANNI TENDE di Tappezzeria Giovanni dal 1967",
  tagline: "Produttori diretti dal 1967",
  phone: "050 878189",
  mobile: "351 7858967",
  email: "tappezzeria.giovanni@gmail.com",
  vatNumber: "01945690509",
  youtubeChannel: "https://youtube.com/@tappezzeriagiovanni7149",
  address: {
    street: "Via Pietro Metastasio 3/5",
    city: "Pisa",
    cap: "56017",
    province: "PI",
    country: "Italia"
  },
  social: {
    facebook: "https://facebook.com/tappezzeriagiovanni",
    instagram: "https://instagram.com/tappezzeriagiovanni",
    youtube: "https://youtube.com/@tappezzeriagiovanni7149"
  },
  workingHours: {
    weekdays: "Lun - Ven: 9:00 - 13:00 / 15:00 - 19:00",
    saturday: "",
    sunday: ""
  }
};

export const heroContent = {
  home: {
    title: "Trasforma il tuo spazio esterno in un'esperienza",
    subtitle: "Soluzioni su misura per outdoor living d'eccellenza",
    cta: "Richiedi un preventivo personalizzato",
    videoUrl: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/ocaep2cm_hf_20260217_173729_8541910f-1fd2-4de2-b3e9-7cfe92715649%20%281%29.mp4",
    imageUrl: "https://customer-assets.emergentagent.com/job_64076d9f-5df4-4045-b4f3-caa897c80892/artifacts/ddj00xrj_fotobionottetoscana.jpeg"
  },
  about: {
    title: "Artigianalità e innovazione dal 1967",
    subtitle: "Ogni progetto è un'opera unica, creata per durare nel tempo"
  },
  tendeDaSole: {
    title: "Tende da Sole",
    subtitle: "Eleganza funzionale per ogni architettura",
    imageUrl: "https://images.unsplash.com/photo-1600566753151-384129cf4e3e?w=1920&q=80"
  },
  pergotende: {
    title: "Pergotende",
    subtitle: "Lo spazio perfetto tra interno ed esterno",
    videoUrl: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/cz63goib_ScreenRecording_02-13-2026%2012-13-59_1.mov",
    imageUrl: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80"
  },
  bioclimatiche: {
    title: "Bioclimatiche",
    subtitle: "Architettura che respira con te",
    videoUrl: "https://customer-assets.emergentagent.com/job_828fb547-63e8-4146-aaa2-2aed84a5e0d5/artifacts/brbi3sp3_bioclimatica%20video%20hero%20%2B.mp4",
    imageUrl: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=1920&q=80"
  },
  vetrate: {
    title: "Vetrate Panoramiche",
    subtitle: "Quando la vista diventa protagonista",
    imageUrl: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80"
  }
};

export const solutions = [
  {
    id: "tende-da-sole",
    title: "Tende da Sole",
    description: "Protezione solare elegante e funzionale per terrazzi, giardini e attività commerciali.",
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/108r6hkd_tende%20da%20sole%20in%20giardino%20%282%29.png",
    link: "/tende-da-sole"
  },
  {
    id: "tende-da-interno",
    title: "Tende da Interno",
    description: "Artigianalità italiana per vestire i tuoi ambienti con tessuti pregiati e design su misura.",
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/77aljmq7_tende%20da%20interno.png",
    link: "/tende-da-interno"
  },
  {
    id: "pergotende",
    title: "Pergotende",
    description: "Strutture versatili che creano ambienti outdoor vivibili in ogni stagione.",
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/bf1sqz8a_hf_20260218_082136_4546cfd5-dbc1-4846-9647-c3157938a14b.png",
    link: "/pergotende"
  },
  {
    id: "bioclimatiche",
    title: "Bioclimatiche",
    description: "Pergole a lamelle orientabili per un controllo perfetto di luce e ventilazione.",
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/zffnyae2_hf_20260213_084850_cad730f6-a65f-449a-92e2-bd4b547c43ba.png",
    link: "/bioclimatiche"
  },
  {
    id: "vetrate",
    title: "Vetrate Panoramiche",
    description: "Chiusure vetrate che ampliano la percezione dello spazio senza limiti visivi.",
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/02f6obxs_hf_20260213_114330_43a647cb-784a-45b0-be9b-75cb4ac45764.png",
    link: "/vetrate-panoramiche"
  }
];

// Opzioni complete per il form preventivo (include tutte le opzioni)
export const allServices = [
  { id: "tende-da-sole", title: "Tende da Sole" },
  { id: "tende-da-interno", title: "Tende da Interno" },
  { id: "pergotende", title: "Pergotende" },
  { id: "bioclimatiche", title: "Bioclimatiche" },
  { id: "vetrate", title: "Vetrate Panoramiche" },
  { id: "vetrate-uffici", title: "Vetrate per Uffici" },
  { id: "tende-ermetiche", title: "Tende Ermetiche" },
  { id: "cambio-telo", title: "Cambio Telo" },
  { id: "cappottina", title: "Cappottina" }
];

export const workMethod = [
  {
    step: 1,
    title: "Consulenza",
    description: "Ascoltiamo le tue esigenze e visitiamo lo spazio per comprendere ogni dettaglio."
  },
  {
    step: 2,
    title: "Progettazione",
    description: "Sviluppiamo una soluzione su misura, integrata perfettamente con l'architettura esistente."
  },
  {
    step: 3,
    title: "Realizzazione",
    description: "Produciamo e installiamo con la massima cura, utilizzando solo materiali premium."
  },
  {
    step: 4,
    title: "Assistenza",
    description: "Ti accompagniamo nel tempo con manutenzione e supporto dedicato."
  }
];

export const brandValues = [
  {
    title: "Produttori Diretti",
    description: "Siamo gli unici produttori diretti di tende da sole in tutta la Toscana. Non rivenditori, ma artigiani con laboratorio e sartoria propria."
  },
  {
    title: "Qualità Prezzo Imbattibile",
    description: "Eliminando gli intermediari, offriamo prezzi competitivi senza compromessi sulla qualità. Vieni in azienda a vedere la differenza."
  },
  {
    title: "Dal 1967 con Passione",
    description: "Oltre 55 anni di esperienza tramandata. Ogni tenda è prodotta nel nostro laboratorio da artigiani esperti."
  }
];

// Testo trafiletto montatori interni (da usare in tutte le pagine)
export const installatoriInterni = {
  title: "Installazione Professionale Garantita",
  text: "Tutti i nostri montaggi sono eseguiti esclusivamente dai nostri dipendenti esperti. Non ci affidiamo a montatori esterni: questo ci permette di garantire la massima qualità e precisione in ogni installazione."
};

export const tendeDaSoleTypes = [
  {
    name: "Tende a Bracci",
    description: "Ideali per terrazzi e balconi, offrono ampia copertura con apertura estendibile. Prodotte nella nostra sartoria.",
    features: ["Apertura fino a 4 metri", "Tessuti Tempotest Parà", "Motorizzazione opzionale"],
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/snjbljcu_Gemini_Generated_Image_pw42wepw42wepw42.png"
  },
  {
    name: "Tende a Caduta",
    description: "Perfette per finestre e verande, proteggono dalla luce diretta mantenendo la vista.",
    features: ["Guide laterali antivento", "Tessuti filtranti", "Design minimale"],
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/sgl3gmdd_IMG_6371.jpeg"
  },
  {
    name: "Cappottine",
    description: "Eleganti soluzioni per ingressi e vetrine. Consegna in 24 ore se portate in azienda!",
    features: ["Forme personalizzabili", "Rifacimento telo in 24h", "Strutture in alluminio"],
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/zfz4k73n_IMG_6369.jpeg"
  },
  {
    name: "Tende Attico",
    description: "Soluzione premium per attici e terrazze di pregio. Design pulito e meccanismo silenzioso.",
    features: ["Estetica raffinata", "Meccanismo nascosto", "Resistenza al vento"],
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/ohszqpr6_Gemini_Generated_Image_du4193du4193du41.png"
  },
  {
    name: "Tende Ermetiche",
    description: "Chiusure laterali certificate classe 6 per il vento. Ideali per gazebi, pergotende e bioclimatiche.",
    features: ["Certificazione Classe 6 Vento", "Chiusura ermetica", "Guide laterali rinforzate"],
    image: "https://customer-assets.emergentagent.com/job_tuscany-tende/artifacts/t1woszpm_IMG_6373.jpeg"
  }
];

export const pergotendeBenefits = [
  "Vivibilità 365 giorni l'anno",
  "Protezione da sole, pioggia e vento",
  "Valorizzazione dell'immobile",
  "Ampliamento dello spazio abitabile",
  "Integrazione domotica avanzata",
  "Design personalizzabile"
];

export const bioclimaticheFeatures = [
  {
    title: "Lamelle Orientabili",
    description: "Controllo totale della luce naturale con inclinazione da 0° a 150°."
  },
  {
    title: "Resistenza Certificata",
    description: "Strutture testate per resistere a carichi neve e vento estremi."
  },
  {
    title: "Integrazione Smart",
    description: "Sensori climatici e controllo da smartphone per il massimo comfort."
  },
  {
    title: "Efficienza Energetica",
    description: "Riduzione dei costi di climatizzazione grazie alla gestione passiva del calore."
  }
];

export const vetrateAdvantages = [
  {
    title: "Luce Naturale",
    description: "Massima luminosità senza compromessi sulla protezione."
  },
  {
    title: "Isolamento Termico",
    description: "Vetri a bassa emissività per comfort in ogni stagione."
  },
  {
    title: "Apertura Totale",
    description: "Sistemi impacchettabili che scompaiono completamente."
  },
  {
    title: "Sicurezza",
    description: "Vetri temperati e stratificati per la massima protezione."
  }
];

export const testimonials = [
  {
    name: "Marco R.",
    location: "Forte dei Marmi",
    text: "Un lavoro impeccabile. La bioclimatica ha trasformato completamente la nostra terrazza."
  },
  {
    name: "Elena S.",
    location: "Livorno",
    text: "Professionalità e attenzione ai dettagli. Il risultato ha superato ogni aspettativa."
  },
  {
    name: "Roberto M.",
    location: "Lucca",
    text: "Finalmente possiamo godere del giardino tutto l'anno. Consigliatissimi."
  }
];
